const state = {
  nav: {},
  rule: {}
};

const getters = {
  getNav: state => {
    return state;
  }
};

const actions = {
  setNav({ commit }, obj) {
    commit("setNav", obj);
  }
};

const mutations = {
  setNav(state, obj) {
    state.nav = obj;

    let tmpMainRoles = [];
    obj.menu.forEach(mainMenu => {
      if (mainMenu.roles && mainMenu.roles.length) {
        tmpMainRoles = mainMenu.roles;

        state.rule[mainMenu.id] = Object.assign([], tmpMainRoles);
        if (mainMenu.subMenu) {
          mainMenu.subMenu.forEach(subMenu => {
            if (subMenu.roles) {
              state.rule[subMenu.id] = Object.assign([], subMenu.roles);
            } else {
              state.rule[subMenu.id] = Object.assign([], tmpMainRoles);
            }
          });
        }
      }
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
